import { render, staticRenderFns } from "./requestdetail.vue?vue&type=template&id=587306fa&scoped=true&"
import script from "./requestdetail.vue?vue&type=script&lang=js&"
export * from "./requestdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587306fa",
  null
  
)

export default component.exports